const c = {
  name: "Andriod",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 33.8 40" style="enable-background:new 0 0 33.8 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5.9,12.5c0-0.9,0.1-1.7,0.3-2.5c0.7-2.4,2.3-4.5,4.5-5.9C10.9,4,11,4,11.1,3.9c0.1-0.1,0.3-0.1,0.4-0.2
			L9.7,0.5C9.7,0.4,9.7,0.1,9.9,0c0.2-0.1,0.4,0,0.5,0.1l1.8,3.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2
			c1.2-0.4,2.6-0.7,4-0.7c1.4,0,2.7,0.2,4,0.7c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.3,0.1,0.4,0.2l1.8-3.2C23.5,0.1,23.6,0,23.7,0
			c0.1,0,0.1,0,0.2,0c0.2,0.1,0.2,0.3,0.1,0.5l-1.7,3.1c0.1,0.1,0.3,0.1,0.4,0.2C22.8,4,22.9,4,23.1,4.1c2.2,1.4,3.8,3.5,4.5,5.9
			c0.2,0.8,0.3,1.7,0.3,2.5H5.9z M12.2,6.7c-0.1-0.1-0.2-0.1-0.4-0.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
			c0.5,0,0.9-0.4,0.9-0.8c0,0,0-0.1,0-0.1C12.7,7.2,12.5,6.9,12.2,6.7z M22.9,7.6c0-0.5-0.4-0.9-0.9-0.9c-0.1,0-0.3,0-0.4,0.1
			c-0.3,0.1-0.5,0.5-0.5,0.8c0,0,0,0.1,0,0.1c0.1,0.5,0.4,0.8,0.9,0.8C22.5,8.5,22.9,8.1,22.9,7.6z"/>
		<path class="st0" d="M0,15.5C0,14.1,1.1,13,2.5,13s2.5,1.1,2.5,2.5v10.3c0,1.4-1.1,2.5-2.5,2.5S0,27.1,0,25.8V15.5z"/>
		<path class="st0" d="M28.9,15.5c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5v10.3c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5
			V15.5z"/>
		<path class="st0" d="M27.1,13.4H5.9v16c0,1.5,1.2,2.7,2.7,2.7h1.8v5.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-5.5h3.3v5.5
			c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5v-5.5h1.8c1.5,0,2.7-1.2,2.7-2.7v-16L27.1,13.4L27.1,13.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Andriod
};
